<template>
  <div>
    <div class="switch">
      <span class="modes" :class='{ active: !mode }' @click="setSwitch(false)">Monthly</span>
      <v-switch
        @change="switchChange"
        v-model="switchModel"
        :color="defaultSwitchColor"
      ></v-switch>
      <span class="modes" :class='{ active: mode }' @click="setSwitch(true)">Annual</span>
    </div>
    <div class="info-price">
      <div id="animatedNumber" ref="animatedNumber">
        <span class="dollar-wrap"><img src="https://sirvwebsite.sirv.com/assets/dollar.svg" alt="Dollar"></span> <span v-html="getPrice"></span><span class="separator">/</span><span class="per-month">month</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'PanelPrice',
  data() {
    return {
      switchModel: this.mode,
      id: 'animatedNumber',
      from: 0,
      to: 39,
      duration: 50,
      defaultSwitchColor: '#2F363F'
    }
  },
  computed: {
    ...mapState([
      'priceValue',
      'mode'
    ]),
    getPrice() {
      return  this.formattedPrice(this.priceValue)
    }
  },
  methods: {
    formattedPrice(price) {
      if (this.mode === false) {
        return price
      } else {
        const roundPrice = Math.floor((this.priceValue * 11) / 12)
        const doublePrice = Math.floor((((this.priceValue * 11) / 12).toFixed(2) - roundPrice) * 100)
        const formattedDoublePrice = doublePrice < 10 ? `0${doublePrice}` : doublePrice
        return `${roundPrice}<span class="double"> . ${formattedDoublePrice}</span>`
      }
    },
    setSwitch(value) {
      this.switchModel = value
      this.switchChange(value)
    },
    switchChange(switchValue) {
      this.$store.dispatch('switchChange', switchValue)
    }
  }
}
</script>
<style lang="scss" scoped>
#animatedNumber {
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  .dollar-wrap {
    display: flex;
    align-items: center;
    width: 9px;
    margin-right: 5px;
    img {
      display: block;
    }
  }
  .double {
    font-size: 20px;
    font-weight: 400;
  }
  .separator {
    font-weight: 400;
    font-size: 20px;
    margin-bottom: -20px;
    margin-left: 5px;
  }
  .per-month {
    font-weight: 400;
    font-size: 20px;
    display: flex;
    align-items: flex-end;
    margin-bottom: -25px;
    line-height: 1;
  }
}
.switch {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    display: inline-flex;
    color: #bbbfc5;
    &.active {
      color: #333940;
    }
    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 10px;
    }
  }
}
.modes {
  cursor: pointer;
  &.active {
    font-weight: 600;
  }
}
.info-price {
  font-size: 56px;
  color: #2f363f;
  margin-bottom: 10px;
}
.additional {
  font-size: 1rem;
  color: #848a8f;
  margin: 0;
  font-weight: 100;
}
::v-deep .double {
  font-size: 16px;
}
</style>
